if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.quickbuyBtn = this.querySelector(".product-form__submit.quickbuy");
        this.errMsg = this.querySelector(".errMsg");
        this.sideCart = document.querySelector("side-cart");
        // this.cartNotification = document.querySelector('cart-notification');

        this.quickbuyBtn?.addEventListener("click", this.onQuickbuy.bind(this));

        this.quickbuyStickyButton = document.querySelector(".product-sticky__submit");

        this.quickbuyStickyButton.addEventListener("click", this.onSubmitHandler.bind(this));
      }

      showError() {
        this.errMsg.classList.add("err-triggered");
      }
      hideError() {
        this.errMsg.classList.remove("err-triggered");
      }

      serializeForm(form) {
        const obj = {};
        const formData = new FormData(form);

        for (const key of formData.keys()) {
          const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

          if (regex.test(key)) {
            obj.properties = obj.properties || {};
            obj.properties[regex.exec(key)[2]] = formData.get(key);
          } else {
            obj[key] = formData.get(key);
          }
        }

        return obj;
      }

      onSubmitHandler(evt) {
        console.log(evt);
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        // this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        // Find selling plan via query string (query string is modified via recharge)
        const urlSearchParams = new URLSearchParams(location.search);
        const sellingPlanId = parseInt(urlSearchParams?.get("selling_plan"));

        // go with this operation if there is a sidecart
        if (this.sideCart) {
          const formValue = this.serializeForm(this.form);
          const properties = !isNaN(sellingPlanId) ? { selling_plan: sellingPlanId } : {};

          if (!formValue.id) {
            this.showError();
            if (evt.target.classList.contains("product-sticky__submit")) {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }
          } else {
            this.sideCart.handleAddItem(evt, null, formValue.id, formValue.quantity, properties);
            this.hideError();
          }

          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          return;
        }
        // otherwise this condition
        else {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
          formData.append("sections_url", window.location.pathname);
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return;
              }
              //
              // this.cartNotification.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            });
        }
      }

      onQuickbuy(event) {
        event.preventDefault();

        const formValue = this.serializeForm(this.form);
        if (!formValue.id) {
          this.showError();
        } else {
          this.sideCart.handleAddItem(event, this.quickbuyBtn, formValue.id, formValue.quantity);
          this.hideError();
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

document.addEventListener("scroll", function (e) {
  const addStickyButton = document.querySelector(".product-sticky__submit");
  const addButton = document.querySelector(".product-form__submit[type='submit']");

  if (addButton && addStickyButton && window.innerWidth >= 1024) {
    if (addButton.getBoundingClientRect().y > 27) {
      addStickyButton.style.display = "none";
    } else {
      addStickyButton.style.display = "block";
    }
  }
});
